import RequestService from '../request-service';

/**
 * handle negotiations
 */
export default class NegotiationsRequestService extends RequestService {
  constructor() {
    super();

    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.betSlipOffer;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'post';
    /**
     * Post parameters
     * @type {{}}
     */

    const { authorizationHeaders } = this.$config;
    this.headers = authorizationHeaders;

    this.postParams = {
      betSlipGroupID: 0,
      isAccepted: false,
    };
  }
}
